export const FEATUREBASE_URL = "https://feedback.spacelift.io/";
